import type { SurfaceEntry, SurfaceSource } from '@/lib/sync/document-surfaces';
import type { PendingRun } from '@/stores/use-template-run-store';

export function recordedSources(
  entry: SurfaceEntry,
  runs: readonly PendingRun[],
): readonly SurfaceSource[] | null {
  if (entry.sources) return entry.sources;
  const matched = runs.find((run) => run.surfaceId === entry.id && run.sources.length > 0);
  return matched?.sources ?? null;
}

export function sourceTitles(
  entry: SurfaceEntry,
  runs: readonly PendingRun[],
  documentTitle: string,
): string[] {
  return recordedSources(entry, runs)?.map((source) => source.title) ?? [documentTitle];
}
